import { Icon } from "@atoms";
import { trackEvent } from "@lib/infrastructure";
import { useExtraServiceUrl } from "@lib/logic";
import { ExtraService } from "@lib/store";
import { FlexCol, FlexRow, H4, P, Subtitle } from "@quarks";
import { cn, getExtrasServicesIcons } from "@utils";
import { useTheme } from "styled-components";

type Props = {
  service: ExtraService;
  meetingId: string | undefined;
  selectedDate: string | undefined;
  locationName: string | undefined;
  titleType?: "H4" | "P";
};

export const ExtraServicesListItem = ({ service, titleType = "H4", locationName, meetingId, selectedDate }: Props) => {
  const { title, description, serviceType } = service;
  const icon = getExtrasServicesIcons(serviceType);

  const url = useExtraServiceUrl(service, meetingId, selectedDate, locationName);

  const handleOnClick = () => {
    trackEvent("ExtraServices_OpenService", {
      serviceType: service.serviceType,
      category: service.category,
      buildingId: service.buildingId,
    });
    window.open(url, "_blank");
  };

  const TitleComponent = titleType === "H4" ? H4 : P;

  return (
    <div
      className={cn(`cursor-pointer`)}
      onClick={handleOnClick}>
      <FlexRow alignItems="center">
        <FlexRow gap={16}>
          <div className="bg-beige-500* flex-none size-10 rounded-md flex items-center justify-center">
            <Icon
              icon={icon}
              size="1.25rem"
            />
          </div>

          <FlexCol alignSelf="center">
            <TitleComponent
              className="truncate flex-1"
              color={useTheme().text.color.body}>
              {title}
            </TitleComponent>
            {description?.length ? <Subtitle fontSize="sm">{description}</Subtitle> : null}
          </FlexCol>
        </FlexRow>

        <Icon
          icon={"openInBrowser"}
          color="#767676"
          size="20px"
        />
      </FlexRow>
    </div>
  );
};
